import { MaintenanceWindowRebootOptionsData } from '../../../maintenanceWindows/maintenanceWindowRebootOptions/types';
import { MaintenanceWindowSchedulerSchema } from '../../../maintenanceWindows/maintenanceWindowScheduler/types';
import { MaintenanceWindowSimpleSchedulerSchema } from '../../../maintenanceWindows/maintenanceWindowSimpleScheduler/types';

export interface MaintenanceWindowPatchSpecificsFormData {
  // all the data needed for rendering
  isEditMode: boolean;
  maintenanceWindowPatchSpecificsData: MaintenanceWindowPatchSpecificsData;
}

export interface MaintenanceWindowPatchSpecificsData {
  scanForPatches: boolean;
  applyPatches: boolean;
  patchScopeSecurity: boolean;
  patchScopeNonSecurity: boolean;
  patchScopeManuallyApproved: boolean;
  manuallyApprovedPatchIds: Array<string>;
  schedulingOptions: {
    useSameSchedule: boolean;
    useFallbackSchedule: boolean;
    runAsSoonAsPossible: boolean;
    schedulerForAll?: MaintenanceWindowSchedulerSchema;
    schedulerScanningPatches?: MaintenanceWindowSchedulerSchema;
    schedulerApplyingPatchesSecurity?: MaintenanceWindowSchedulerSchema;
    schedulerApplyingPatchesNonSecurity?: MaintenanceWindowSchedulerSchema;
    fallbackSchedulers?: {
      schedulerForAll: MaintenanceWindowSimpleSchedulerSchema;
      schedulerScanningPatches: MaintenanceWindowSimpleSchedulerSchema;
      schedulerApplyingPatchesSecurity: MaintenanceWindowSimpleSchedulerSchema;
      schedulerApplyingPatchesNonSecurity: MaintenanceWindowSimpleSchedulerSchema;
    };
  };
  runOnSystemChanges: boolean;
  fallbackOnDirectDownload: boolean;
  vendorProductsPairsType: string;
  rebootOptions?: MaintenanceWindowRebootOptionsData;
  vendorProductsPairs?: Array<any>;
  cachingServers?: Array<any>;
}

export type ShorthandPatchScopeField = 'apply' | 'security' | 'nonSecurity' | 'manuallyApproved';

export interface FormEnablingConfig {
  targetScope: TargetScopeEnablingConfig;
  schedulingOptions: SchedulingOptionsEnablingConfig;
  rebootOptions: boolean;
  additionalSettings: AdditionalPatchSettingsEnablingConfig;
}

export interface TargetScopeEnablingConfig {
  apply: boolean;
  security: boolean;
  nonSecurity: boolean;
  manuallyApproved: boolean;
  manuallyApprovedSelector: boolean;
}

export interface SchedulingOptionsEnablingConfig {
  smartScan: boolean;
  useSameSchedule: boolean;
  useFallback: boolean;
  sameOldSchedule: boolean;
  sameNewSchedule: boolean;
  scanOldSchedule: boolean;
  scanNewSchedule: boolean;
  securityOldSchedule: boolean;
  securityNewSchedule: boolean;
  nonSecurityOldSchedule: boolean;
  nonSecurityNewSchedule: boolean;
  ifMissedRunAsap: boolean;
}

export interface AdditionalPatchSettingsEnablingConfig {
  relay: boolean;
  useVendorWebsites: boolean;
  vendorProductsRadio: boolean;
  vendorProductsSelector: boolean;
}

export enum Schedulers {
  SAME,
  SCAN,
  APPLY_SECURITY,
  APPLY_NON_SECURITY,
}
